import gql from 'graphql-tag';

import { locationFragment } from '../../../api/fragments/location';

export const createMatchMutation = gql`
	mutation CreateMatch($input: MatchInput) {
		createMatch(input: $input) {
			id
			type
			gameType
			format
			location {
				...locationInfo
			}
			division {
				id
				name
			}
			tournament {
				id
				name
			}
			players {
				id
				name
			}
			teams {
				id
				name
			}
			games {
				id
				createdAt
			}
			status
			verified
			startTime
			createdAt
		}
	}
	${locationFragment}
`;
